module.exports = {"apiUrl":"https://api.hejfish.com","apiKey":"JerduM05YietG9dj8jLs7LCClEv9ACKC2vEp71Lf"};